import { apiClient } from './client'

export type ApplicationHealthIncidentStatus = 'New' | 'Acknowledged' | 'Resolved'

export type ApplicationHealthReasonCode =
  | 'data_store_failure'
  | 'dependency_failure'
  | 'timeout'
  | 'server_error_response'
  | 'unhandled_exception'

export type ApplicationHealthIncident = {
  status: ApplicationHealthIncidentStatus
  reasonCode: ApplicationHealthReasonCode
  httpStatus: number
  httpMethod: string
  routeTemplate: string
  occurrenceCount: number
  firstSeenAt: string
  lastSeenAt: string
  correlationReference: string
}

export type ApplicationHealthIncidentListResponse = {
  items: ApplicationHealthIncident[]
  newCount: number
  acknowledgedCount: number
  hasMore: boolean
}

export type ApplicationHealthIncidentFilters = {
  status?: 'active' | 'new' | 'acknowledged' | 'resolved' | 'all'
  reasonCode?: ApplicationHealthReasonCode
  httpStatus?: number
  httpMethod?: string
  routeTemplate?: string
  limit?: number
}

export async function getApplicationHealthIncidents(filters: ApplicationHealthIncidentFilters = {}) {
  const { data } = await apiClient.get<ApplicationHealthIncidentListResponse>(
    '/api/admin/application-health/incidents',
    { params: filters }
  )
  return data
}

export async function updateApplicationHealthIncidentStatus(
  correlationReference: string,
  status: ApplicationHealthIncidentStatus
) {
  const { data } = await apiClient.patch<ApplicationHealthIncident>(
    `/api/admin/application-health/incidents/${encodeURIComponent(correlationReference)}/status`,
    { status }
  )
  return data
}
